import { IParticipantsPair } from 'twain-sport-fe-mono/interfaces';

export const getRankIntro = (participants: IParticipantsPair): string => {
    const list = [];

    if (Math.abs(participants.left.rank - participants.right.rank) === 1) {
        list.push('1');
    } else if (Math.abs(participants.left.rank - participants.right.rank) >= 10) {
        list.push('2');
    }
    if (participants.left.rank > 14 && participants.right.rank > 14) {
        list.push('3');
    }

    return list.length ? list[Math.floor(Math.random() * list.length)] : null;
};
